export enum UserLevels {
  SUPER_ADMIN = "SUPERADMIN",
  ADMIN = "ADMIN",
  STANDARD = "STANDARD"
}
